module.exports = __webpack_public_path__ + "cfc8601f307a60845942071e3f32a347.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/theater.jpg
// module id = 910
// module chunks = 0